import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CohortInsight } from "@/types/cohort.types";
import { Lightbulb, TrendingUp, AlertTriangle, Info } from "lucide-react";

interface CohortInsightsProps {
  insights: CohortInsight[];
}

export const CohortInsights = ({ insights }: CohortInsightsProps) => {
  const getIcon = (type: string) => {
    switch (type) {
      case 'success': return <TrendingUp className="h-4 w-4" />;
      case 'warning': return <AlertTriangle className="h-4 w-4" />;
      default: return <Info className="h-4 w-4" />;
    }
  };

  const getVariant = (type: string): "default" | "destructive" => {
    return type === 'warning' ? 'destructive' : 'default';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Lightbulb className="h-5 w-5 text-yellow-500" />
          💡 Automatische Insights
        </CardTitle>
        <CardDescription>
          Wichtige Erkenntnisse aus der Kohortenanalyse
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {insights.length > 0 ? (
          insights.map((insight, index) => (
            <Alert key={index} variant={getVariant(insight.type)}>
              <div className="flex items-start gap-2">
                {getIcon(insight.type)}
                <AlertDescription>{insight.message}</AlertDescription>
              </div>
            </Alert>
          ))
        ) : (
          <div className="text-center py-6 text-muted-foreground">
            <Info className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>Noch keine Insights verfügbar. Warten Sie auf mehr Daten.</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
